module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M18.51 16.002h6.692a1.671 1.671 0 1 1 0 3.344H18.51a1.671 1.671 0 1 1 0-3.344zm8.364-13.386H5.126c-.924 0-1.672.748-1.672 1.674v23.422a1.673 1.673 0 0 0 3.344 0V5.962h20.076c.924 0 1.672-.748 1.672-1.672a1.672 1.672 0 0 0-1.672-1.674z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/fda-secondary.js
// module id = 1143
// module chunks = 14